"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePopover = void 0;
var react_1 = require("react");
function usePopover() {
    var _a = react_1.useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var isOpen = react_1.useMemo(function () { return !!anchorEl; }, [anchorEl]);
    var setPopoverOpen = react_1.useCallback(function (event) {
        setAnchorEl(event.currentTarget);
    }, [setAnchorEl]);
    var setPopoverClose = react_1.useCallback(function () {
        setAnchorEl(null);
    }, [setAnchorEl]);
    return { anchorEl: anchorEl, setPopoverClose: setPopoverClose, setPopoverOpen: setPopoverOpen, isOpen: isOpen };
}
exports.usePopover = usePopover;
